module.exports = __webpack_public_path__ + "static/media/Total_Assets_Icon.e1c7cc45.svg";